{
  "title": "مسارات الاعتماد",
  "actions": {
    "new": "مسار جديد",
    "edit": "تعديل",
    "test": "اختبار",
    "duplicate": "نسخ",
    "disable": "إيقاف",
    "enable": "تفعيل",
    "viewRuns": "عرض الطلبات",
    "delete": "حذف",
    "cancel": "إلغاء",
    "saveDraft": "حفظ المسودة",
    "publish": "نشر",
    "discardDraft": "تجاهل المسودة",
    "more": "إجراءات أخرى",
    "rowActions": "إجراءات {{name}}"
  },
  "fields": {
    "name": "المسار",
    "nameEn": "الاسم (بالإنجليزية)",
    "nameAr": "الاسم (بالعربية)",
    "description": "الوصف",
    "subject": "نوع المستند",
    "trigger": "المُشغِّل",
    "scope": "ينطبق على",
    "priority": "الترتيب",
    "published": "المنشور",
    "state": "الحالة",
    "requests": "الطلبات الحالية",
    "updated": "آخر تحديث",
    "created": "تاريخ الإنشاء"
  },
  "trigger": {
    "purchase": "تقديم المشتريات للاعتماد",
    "project_budget": "تقديم موازنة مشروع للاعتماد",
    "when": {
      "purchase": "عند تقديم المشتريات للاعتماد",
      "project_budget": "عند تقديم موازنة مشروع للاعتماد",
      "project_variation": "عند إرسال أمر تغييري للموافقة الداخلية",
      "project_claim": "عند إرسال مستخلص للموافقة الداخلية",
      "service_contract": "عند تفعيل عقد صيانة يحتاج إلى اعتماد"
    },
    "project_variation": "أمر تغييري مُرسل للموافقة الداخلية",
    "project_claim": "مستخلص مُرسل للموافقة الداخلية",
    "service_contract": "عقد صيانة مُرسل للاعتماد"
  },
  "state": {
    "active": "نشط",
    "disabled": "موقوف",
    "draftOnly": "مسودة فقط",
    "draftChanges": "تغييرات غير منشورة",
    "explain": {
      "active": "نشط: تُوجَّه الطلبات الجديدة المطابقة عبر النسخة المنشورة.",
      "disabled": "موقوف: تتجاوز الطلبات الجديدة هذا المسار، وتكتمل الطلبات الجارية على نسختها.",
      "draftOnly": "مسودة فقط: لم يُنشر بعد، فلا يوجّه أي طلب."
    }
  },
  "counts": {
    "inProgress_zero": "لا طلبات جارية",
    "inProgress_one": "طلب جارٍ واحد",
    "inProgress_two": "طلبان جاريان",
    "inProgress_few": "{{n}} طلبات جارية",
    "inProgress_many": "{{n}} طلبًا جاريًا",
    "inProgress_other": "{{n}} طلب جارٍ",
    "blocked_zero": "لا طلبات متوقفة",
    "blocked_one": "طلب متوقف واحد",
    "blocked_two": "طلبان متوقفان",
    "blocked_few": "{{n}} طلبات متوقفة",
    "blocked_many": "{{n}} طلبًا متوقفًا",
    "blocked_other": "{{n}} طلب متوقف",
    "failed_zero": "لا إجراءات متعثرة",
    "failed_one": "إجراء متعثر واحد",
    "failed_two": "إجراءان متعثران",
    "failed_few": "{{n}} إجراءات متعثرة",
    "failed_many": "{{n}} إجراءً متعثرًا",
    "failed_other": "{{n}} إجراء متعثر"
  },
  "list": {
    "title": "مسارات الاعتماد",
    "subtitle": "أي المستندات تحتاج إلى اعتماد، ومن يعتمدها، وبأي ترتيب.",
    "tableLabel": "مسارات الاعتماد",
    "searchPlaceholder": "ابحث في أسماء المسارات…",
    "searchLabel": "البحث في المسارات",
    "clearSearch": "مسح البحث",
    "stateFilter": "الحالة",
    "allStates": "كل الحالات",
    "stateOption": {
      "active": "نشط",
      "disabled": "موقوف",
      "unpublished": "مسودة فقط"
    },
    "subjectFilter": "نوع المستند",
    "allSubjects": "كل أنواع المستندات",
    "clearFilters": "مسح عوامل التصفية",
    "runsLink": "طلبات الاعتماد",
    "noSpec": "لم يُضبط بعد",
    "viewRunsOf": "طلبات {{name}}",
    "empty": {
      "title": "لا توجد مسارات اعتماد بعد",
      "body": "يحدد المسار أي المستندات (المشتريات، موازنات المشاريع) يجب اعتمادها، ومن يعتمدها، وبأي ترتيب. وبدونه يرحّلها أو يعتمدها مباشرة من يملك الصلاحية.",
      "bodyEdit": "أنشئ مسارًا، واختبره بقيم تجريبية، ثم انشره.",
      "filteredTitle": "لا توجد مسارات مطابقة",
      "filteredBody": "جرّب اسمًا أو حالة أو نوع مستند آخر."
    }
  },
  "create": {
    "title": "مسار جديد",
    "body": "تضبط الشروط وخطوات الاعتماد في الخطوة التالية. لا يتغير شيء قبل النشر.",
    "startBody": "ابدأ بمسار فارغ، أو بقالب تكيّفه مع شركتك. لا يتغير شيء قبل النشر.",
    "templateBody": "حدّد المبالغ ومن يعتمد. يُنشأ المسار مسودةً: راجعه واختبره في المُنشئ ثم انشره.",
    "startFrom": "البدء من",
    "blank": "مسار فارغ",
    "blankHint": "تضبط الشروط وخطوات الاعتماد بنفسك في المُنشئ.",
    "template": "القالب",
    "change": "تغيير",
    "amounts": "المبالغ",
    "paramHint": "المقترح: {{amount}}",
    "descriptionHint": "الغرض من هذا المسار، لمن يتولون صيانته.",
    "subjectHint": "نوع المستند الذي يوجّه هذا المسار طلبات اعتماده.",
    "submit": "إنشاء المسار",
    "continue": "متابعة",
    "back": "رجوع"
  },
  "templates": {
    "steps": "الخطوات",
    "then": " ← ",
    "everyone": "{{step}} (الجميع)",
    "above": "{{step}} (فوق {{amount}})",
    "applies": "فوق {{amount}}: {{steps}}"
  },
  "disable": {
    "title": "إيقاف {{name}}؟",
    "body": "لن تُوجَّه الطلبات الجديدة عبر هذا المسار بعد الآن."
  },
  "enable": {
    "title": "تفعيل {{name}}؟",
    "body": "ستُوجَّه الطلبات الجديدة المطابقة عبر نسخته المنشورة من جديد."
  },
  "delete": {
    "title": "حذف {{name}}؟",
    "body": "سيُحذف المسار ومسودته. لا يمكن التراجع عن ذلك.",
    "publishedReason": "تُحفظ المسارات المنشورة للاحتفاظ بسجلها. أوقفه بدلًا من حذفه."
  },
  "discard": {
    "title": "تجاهل المسودة؟",
    "body": "ستُزال تغييراتك غير المنشورة، وتبقى النسخة {{n}} منشورة."
  },
  "impact": {
    "running_zero": "لا توجد طلبات جارية تتأثر بذلك.",
    "running_one": "يحتفظ الطلب الجاري الواحد بخطواته الحالية.",
    "running_two": "يحتفظ الطلبان الجاريان بخطواتهما الحالية.",
    "running_few": "تحتفظ {{n}} طلبات جارية بخطواتها الحالية.",
    "running_many": "يحتفظ {{n}} طلبًا جاريًا بخطواته الحالية.",
    "running_other": "يحتفظ {{n}} طلب جارٍ بخطواته الحالية."
  },
  "leave": {
    "title": "المغادرة دون حفظ؟",
    "body": "لم تُحفظ تغييراتك على هذا المسار بعد.",
    "confirm": "مغادرة",
    "cancel": "البقاء"
  },
  "toast": {
    "created": "أُنشئ المسار",
    "createdFromTemplate": "أُنشئ المسار مسودةً. راجعه واختبره ثم انشره.",
    "duplicated": "أُنشئت نسخة: {{name}}",
    "disabled": "أُوقف {{name}}",
    "enabled": "فُعِّل {{name}}",
    "deleted": "حُذف {{name}}",
    "draftSaved": "حُفظت المسودة",
    "discarded": "تم تجاهل المسودة",
    "published": "نُشرت النسخة {{n}}",
    "priority": "تغيّر الترتيب إلى {{n}}"
  },
  "errors": {
    "WORKFLOW_ACTION_NOT_ALLOWED": "لا يمكنك نشر مسار يرحّل المشتريات تلقائيًا: لا تملك صلاحية ترحيل المشتريات.",
    "WORKFLOW_PRIORITY_TAKEN": "يوجد مسار آخر لنوع المستند نفسه يحمل رقم الترتيب هذا.",
    "WORKFLOW_INVALID": "لا يمكن حفظ المسار أو نشره بوضعه الحالي. عالج المشكلات المُشار إليها.",
    "VERSION_CONFLICT": "غيّر شخص آخر هذا المسار. أعد تحميله وحاول مرة أخرى."
  },
  "problems": {
    "unknownField": "اختر حقلًا.",
    "badOperator": "هذه المقارنة لا تنطبق على الحقل.",
    "noValue": "لا تحتاج هذه المقارنة إلى قيمة.",
    "chooseValues": "اختر قيمة واحدة على الأقل.",
    "amount": "أدخل مبلغًا بثلاث منازل عشرية على الأكثر.",
    "chooseValue": "اختر قيمة.",
    "duplicateKey": "خطوتان تحملان المفتاح نفسه.",
    "listedTwice": "مذكور مرتين.",
    "noAssignees": "اختر من يعتمد هذه الخطوة.",
    "reminderAfterDue": "يجب أن يسبق التذكيرُ موعدَ الاستحقاق.",
    "noSteps": "أضف خطوة اعتماد واحدة على الأقل.",
    "allConditional": "يجب أن تعمل خطوة واحدة على الأقل دائمًا، حتى لا تمر مشتريات مطابقة دون معتمِد.",
    "badAction": "هذا الإجراء غير متاح لنوع المستند.",
    "noDraft": "لا توجد مسودة للنشر.",
    "missingAssignee": "هذا الدور أو المستخدم لم يعد موجودًا.",
    "taken": "مستخدم في مسار آخر.",
    "nameStep": "سمِّ الخطوة.",
    "nameWorkflow": "سمِّ المسار.",
    "tooDeep": "لا يمكن تداخل الشروط لأكثر من 3 مستويات.",
    "enterAmount": "أدخل مبلغًا.",
    "amountPositive": "يجب أن يكون المبلغ أكبر من صفر.",
    "amountAbove": "يجب أن يكون هذا المبلغ أكبر من المبلغ الأول.",
    "unknownSlot": "لا يتضمن هذا القالب مجموعة المعتمِدين هذه.",
    "unknownAmount": "لا يتضمن هذا القالب هذا المبلغ.",
    "number": "أدخل رقمًا.",
    "date": "أدخل تاريخًا.",
    "text": "أدخل قيمة.",
    "enumValue": "اختر إحدى القيم المدرجة.",
    "timerUnits": "يجب أن يستخدم التذكير وموعد الاستحقاق الوحدة نفسها.",
    "noFallback": "اختر الدور الذي يقرر عندما لا يوجد رئيس.",
    "orgField": "اختر حقلًا يحمل وحدة تنظيمية.",
    "requesterField": "تُستخدم الوحدة الأساسية لمقدم الطلب: لا حاجة إلى حقل.",
    "timerShapes": "حدد الوقت إما بالساعات أو بوحدة.",
    "missingFallbackRole": "هذا الدور لم يعد موجودًا.",
    "atMost": "الحد الأقصى {{max}}."
  },
  "checks": {
    "MISSING_ASSIGNEE": "هذا الدور أو المستخدم لم يعد موجودًا.",
    "MISSING_FALLBACK_ROLE": "هذا الدور لم يعد موجودًا.",
    "ORG_RELATIVE_STEP": "من يقرر في «{{step}}» يتوقف على وحدة كل مستند والهيكل التنظيمي: جرّبه بقيم نموذجية لترى من سيقرر.",
    "FALLBACK_NO_ONE": "لا أحد في الدور البديل للخطوة «{{step}}» يستطيع القرار اليوم (غير نشط، أو بلا صلاحية «{{permission}}»): المستند الذي يكون كل رؤسائه شاغرين أو مستثنين سيتوقف.",
    "NO_ONE_CAN_DECIDE": "لا أحد يستطيع القرار في «{{step}}» اليوم (غير نشط، أو بلا صلاحية «{{permission}}»): ستتوقف الطلبات المقدمة.",
    "ONLY_ONE_CAN_DECIDE": "{{name}} وحده يستطيع القرار في «{{step}}»: ستتوقف الطلبات التي يقدمها بنفسه.",
    "NO_HOLIDAYS": "التذكيرات ومواعيد الاستحقاق بأيام العمل تتخطى العطلات، لكن لم تُدخل عطلات لعام {{year}}: أضفها من الإعدادات ← التقويم.",
    "SHADOWED": "«{{name}}» (الترتيب {{order}}) ينطبق على كل مستند من نوع {{subject}} ويأتي أولًا، فلن يُختار هذا المسار أبدًا."
  },
  "sentence": {
    "every": {
      "purchase": "كل فاتورة شراء تُقدَّم للاعتماد",
      "project_budget": "كل موازنة مشروع تُقدَّم للاعتماد",
      "project_variation": "كل أمر تغييري يُرسل للموافقة الداخلية",
      "project_claim": "كل مستخلص يُرسل للموافقة الداخلية",
      "service_contract": "كل عقد صيانة يُفعَّل"
    },
    "when": "عندما",
    "onlyWhen": "فقط عندما",
    "and": "و",
    "or": "أو",
    "comma": "، ",
    "anything": "أي شيء",
    "noneOf": "لا شيء من",
    "notAllOf": "ليس كل"
  },
  "names": {
    "hidden": {
      "supplier": "مورد لا يمكنك رؤيته",
      "supplierGroup": "مجموعة موردين لا يمكنك رؤيتها",
      "warehouse": "مستودع لا يمكنك رؤيته",
      "role": "دور لا يمكنك رؤيته",
      "user": "مستخدم لا يمكنك رؤيته",
      "orgUnit": "وحدة تنظيمية لا يمكنك رؤيتها",
      "projectType": "نوع مشروع لا يمكنك رؤيته"
    }
  },
  "picker": {
    "supplier": "اختر موردًا",
    "addSupplier": "أضف موردًا",
    "supplierGroup": "اختر مجموعات الموردين",
    "warehouse": "اختر مستودعًا",
    "role": "اختر الأدوار",
    "orgUnit": "اختر وحدة تنظيمية",
    "projectType": "اختر نوع مشروع",
    "search": "بحث…",
    "empty": "لا توجد نتائج مطابقة.",
    "clear": "مسح",
    "remove": "إزالة",
    "selected_zero": "لم يُختر شيء",
    "selected_one": "عنصر واحد مختار",
    "selected_two": "عنصران مختاران",
    "selected_few": "{{n}} عناصر مختارة",
    "selected_many": "{{n}} عنصرًا مختارًا",
    "selected_other": "{{n}} عنصر مختار",
    "noAccess": {
      "supplier": "لا يمكنك البحث في الموردين",
      "supplierGroup": "لا يمكنك البحث في مجموعات الموردين",
      "warehouse": "لا يمكنك البحث في المستودعات",
      "role": "البحث في الأدوار متاح لمحرري المسارات فقط",
      "orgUnit": "الوحدات التنظيمية غير متاحة",
      "projectType": "لا يمكنك البحث في أنواع المشاريع، أو أن المشاريع معطّلة"
    },
    "enum": "اختر قيمة"
  },
  "conditions": {
    "add": "أضف شرطًا",
    "addRule": "إضافة شرط",
    "addGroup": "إضافة مجموعة",
    "removeAll": "إزالة كل الشروط",
    "removeGroup": "إزالة المجموعة",
    "removeRule": "إزالة الشرط على {{field}}",
    "match": "طريقة جمع الشروط",
    "matchAll": "كل هذه الشروط متحققة",
    "matchAny": "أي من هذه الشروط متحقق",
    "groupLegend": "مجموعة شروط، المستوى {{depth}}",
    "emptyGroup": "المجموعة الفارغة لا تقيّد شيئًا.",
    "field": "الحقل",
    "operator": "المقارنة",
    "valueOf": "قيمة {{field}}",
    "if": "إذا",
    "mode": {
      "all": "كل هذه الشروط",
      "any": "أيٌّ من هذه الشروط",
      "none": "لا شيء من هذه الشروط",
      "notAll": "ليست كل هذه الشروط"
    },
    "modeHint": {
      "none": "تتحقق عندما لا يتحقق أي من الشروط أدناه.",
      "notAll": "تتحقق عندما لا يتحقق شرط واحد على الأقل من الشروط أدناه."
    },
    "textListHint": "افصل بين القيم بفواصل."
  },
  "assignees": {
    "placeholder": "اختر المستخدمين والأدوار",
    "search": "ابحث في المستخدمين والأدوار…",
    "roles": "الأدوار",
    "users": "المستخدمون",
    "chosen": "المعتمِدون المختارون",
    "none": "لم يُختر أحد بعد",
    "roleTag": "(دور)",
    "headOfSubject": "رئيس وحدة المستند",
    "headOfRequester": "رئيس وحدة مقدم الطلب",
    "hrbpOfSubject": "شريك الموارد البشرية لوحدة المستند",
    "hrbpOfRequester": "شريك الموارد البشرية لوحدة مقدم الطلب",
    "levelsUp": "(المستوى +{{n}})",
    "roleMembers_zero": "(دور، لا أعضاء نشطين)",
    "roleMembers_one": "(دور، عضو نشط واحد)",
    "roleMembers_two": "(دور، عضوان نشطان)",
    "roleMembers_few": "(دور، {{n}} أعضاء نشطين)",
    "roleMembers_many": "(دور، {{n}} عضوًا نشطًا)",
    "roleMembers_other": "(دور، {{n}} عضو نشط)",
    "fewPeople_zero": "لا يوجد أي شخص مسمّى. لن يتمكن أحد من الاعتماد وسيتوقف الطلب.",
    "fewPeople_one": "يوجد شخص واحد مسمّى فقط. إذا أعدّ هذا الشخص المشتريات أو قدّمها فلن يتمكن أحد من اعتمادها وسيتوقف الطلب.",
    "fewPeople_two": "يوجد شخصان مسمّيان فقط. إذا لم يتمكن غيرهما من الاعتماد سيتوقف الطلب.",
    "fewPeople_few": "يوجد {{n}} أشخاص مسمّين فقط. إذا لم يتمكن غيرهم من الاعتماد سيتوقف الطلب.",
    "fewPeople_many": "يوجد {{n}} شخصًا مسمّى فقط. إذا لم يتمكن غيرهم من الاعتماد سيتوقف الطلب.",
    "fewPeople_other": "يوجد {{n}} شخص مسمّى فقط. إذا لم يتمكن غيرهم من الاعتماد سيتوقف الطلب.",
    "help": "المعتمِدون هم مستخدمون مسمّون أو أدوار موجودة أو رؤساء وشركاء موارد بشرية يُحدَّدون من الهيكل التنظيمي لكل مستند. ويجب أن يكون المعتمِد نشطًا، وأن يملك صلاحية اعتماد المشتريات والاطلاع عليها، وألا يكون من أعدّ المشتريات أو قدّمها.",
    "organisation": "الهيكل التنظيمي",
    "orgHint": "يُحدَّد من الهيكل التنظيمي لكل مستند",
    "level": "أي رئيس",
    "levelSelf": "الوحدة نفسها",
    "fallbackPrefix": "وإلا فالدور",
    "noFallback": "لم يُختر دور بديل بعد",
    "levelUp_zero": "{{n}} مستوى للأعلى",
    "levelUp_one": "مستوى واحد للأعلى",
    "levelUp_two": "مستويان للأعلى",
    "levelUp_few": "{{n}} مستويات للأعلى",
    "levelUp_many": "{{n}} مستوى للأعلى",
    "levelUp_other": "{{n}} مستوى للأعلى"
  },
  "completion": {
    "any": "أيٌّ منهم",
    "anyHint": "أول معتمِد مؤهل يُكمل الخطوة.",
    "all": "الجميع",
    "allHint": "يجب أن يعتمد كل معتمِد مؤهل.",
    "anyPrefix": "أيٌّ من",
    "allPrefix": "جميع",
    "anyStamp": "أيٌّ منهم",
    "allStamp": "الجميع"
  },
  "timing": {
    "reminder": "تذكير بعد {{time}}",
    "due": "الاستحقاق بعد {{time}}",
    "none": "بلا تذكير أو موعد استحقاق",
    "amount": {
      "HOURS_zero": "{{n}} ساعة",
      "HOURS_one": "ساعة واحدة",
      "HOURS_two": "ساعتين",
      "HOURS_few": "{{n}} ساعات",
      "HOURS_many": "{{n}} ساعة",
      "HOURS_other": "{{n}} ساعة",
      "WORKING_HOURS_zero": "{{n}} ساعة عمل",
      "WORKING_HOURS_one": "ساعة عمل واحدة",
      "WORKING_HOURS_two": "ساعتي عمل",
      "WORKING_HOURS_few": "{{n}} ساعات عمل",
      "WORKING_HOURS_many": "{{n}} ساعة عمل",
      "WORKING_HOURS_other": "{{n}} ساعة عمل",
      "WORKING_DAYS_zero": "{{n}} يوم عمل",
      "WORKING_DAYS_one": "يوم عمل واحد",
      "WORKING_DAYS_two": "يومي عمل",
      "WORKING_DAYS_few": "{{n}} أيام عمل",
      "WORKING_DAYS_many": "{{n}} يوم عمل",
      "WORKING_DAYS_other": "{{n}} يوم عمل"
    }
  },
  "step": {
    "defaultName": "الاعتماد {{n}}",
    "nameEn": "اسم الخطوة (بالإنجليزية)",
    "nameAr": "اسم الخطوة (بالعربية)",
    "who": "من يعتمد",
    "whoPicker": "المعتمِدون",
    "completion": "كم يجب أن يعتمد",
    "when": "متى تعمل هذه الخطوة",
    "whenShort": "تعمل",
    "timingShort": "التوقيت",
    "separationShort": "الفصل بين المهام",
    "always": "دائمًا",
    "addWhen": "تعمل فقط عندما…",
    "reminder": "التذكير بعد",
    "due": "الاستحقاق بعد",
    "separation": "لا يعتمد هذه الخطوة من اعتمد خطوة سابقة",
    "separationHint": "الفصل بين المهام: يُستبعد هنا من اعتمد خطوة سابقة في الطلب نفسه.",
    "separationOn": "يُستبعد المعتمِدون السابقون",
    "separationOff": "يجوز للمعتمِدين السابقين الاعتماد مرة أخرى",
    "blocked": "إذا لم يتمكن أحد من الاعتماد: يتوقف الطلب ويُنبَّه المسؤولون.",
    "unit": "احتساب الوقت بـ",
    "units": {
      "HOURS": "ساعات تقويمية",
      "WORKING_HOURS": "ساعات عمل",
      "WORKING_DAYS": "أيام عمل"
    },
    "unitHint": {
      "HOURS": "ساعات تقويمية من بدء الخطوة، تشمل الليالي وعطلات نهاية الأسبوع والعطل الرسمية.",
      "WORKING_HOURS": "ساعات يوم العمل في الشركة، دون عطلات نهاية الأسبوع والعطل الرسمية.",
      "WORKING_DAYS": "أيام العمل في تقويم الشركة، دون عطلات نهاية الأسبوع والعطل الرسمية."
    },
    "orgTitle": "عندما يُحدَّد المعتمِد من الهيكل التنظيمي",
    "fallback": "إذا لم يوجد رئيس",
    "fallbackHint": "يقرر أعضاء هذا الدور عندما يكون كل رئيس في التسلسل شاغرًا أو مستبعدًا.",
    "walkUp": "عدد المستويات للصعود",
    "walkUpHint": "كم وحدة أعلى تُجرَّب عندما يكون الرئيس شاغرًا أو لا يستطيع الاعتماد (من 0 إلى 10)."
  },
  "builder": {
    "label": "خطوات المسار بالترتيب",
    "trigger": "المُشغِّل",
    "triggerHint": "ثابت لنوع المستند هذا.",
    "appliesTo": "ينطبق على",
    "stepTitle": "الخطوة {{n}}",
    "addTitle": "أضف خطوة",
    "addStep": "إضافة خطوة اعتماد",
    "noSteps": "لا توجد خطوات اعتماد بعد. يحتاج المسار إلى خطوة واحدة على الأقل قبل نشره.",
    "outcomes": "النتائج",
    "editStep": "تعديل الخطوة",
    "editing": "قيد التعديل",
    "moveUp": "نقل {{name}} إلى الأعلى",
    "moveDown": "نقل {{name}} إلى الأسفل",
    "removeStep": "إزالة {{name}}",
    "stepProblems_zero": "لا مشكلات",
    "stepProblems_one": "مشكلة واحدة تحتاج إلى معالجة",
    "stepProblems_two": "مشكلتان تحتاجان إلى معالجة",
    "stepProblems_few": "{{n}} مشكلات تحتاج إلى معالجة",
    "stepProblems_many": "{{n}} مشكلة تحتاج إلى معالجة",
    "stepProblems_other": "{{n}} مشكلة تحتاج إلى معالجة",
    "panel": "إعدادات الخطوة",
    "panelTitle": "إعدادات الخطوة {{n}}",
    "helpTitle": "كيف يعمل المُنشئ",
    "helpSelect": "اختر «تعديل الخطوة» على البطاقة لتغيير معتمِديها ومتى تعمل وتوقيتها هنا.",
    "helpAssignees": "يعتمد المستخدمون المسمّون والأدوار الموجودة فقط. لا يوجد توجيه حسب المدير أو القسم أو الفرع.",
    "helpOrder": "تعمل الخطوات من الأعلى إلى الأسفل؛ تبدأ الخطوة التالية حين تكتمل التي قبلها.",
    "readOnlyTitle": "للقراءة فقط",
    "readOnlyBody": "يمكنك الاطلاع على هذا المسار دون تغييره.",
    "editsPublished": "تعرض النسخة {{n}}. تصبح تغييراتك مسودة جديدة عند الحفظ.",
    "unsaved": "تغييرات غير محفوظة",
    "fixFirst_zero": "لا مشكلات تمنع الحفظ.",
    "fixFirst_one": "عالج مشكلة واحدة قبل الحفظ.",
    "fixFirst_two": "عالج مشكلتين قبل الحفظ.",
    "fixFirst_few": "عالج {{n}} مشكلات قبل الحفظ.",
    "fixFirst_many": "عالج {{n}} مشكلة قبل الحفظ.",
    "fixFirst_other": "عالج {{n}} مشكلة قبل الحفظ."
  },
  "outcome": {
    "approved": "معتمد",
    "approvedLabel": "الإجراء بعد الاعتماد",
    "leave": "تبقى المشتريات معتمدة؛ ويرحّلها من يملك صلاحية الترحيل",
    "leaveHint": "تنتظر المشتريات، معتمدةً، أن يرحّلها شخص.",
    "actionPermission": "يتطلب نشر ذلك صلاحية «{{permission}}»، وأنت تملكها.",
    "actionPermissionMissing": "يتطلب نشر ذلك صلاحية «{{permission}}»، وأنت لا تملكها.",
    "rejected": "مرفوض",
    "rejectedText": "ينتهي الطلب وتعود المشتريات مسودة قابلة للتعديل، ولا يُعاد تقديمها إلا بعد تغييرها.",
    "returned": "مُعاد",
    "returnedText": "ينتهي الطلب وتعود المشتريات إلى من قدّمها لإجراء التعديلات؛ وتقديمها مجددًا يبدأ طلبًا جديدًا.",
    "actionAfter": "الإجراء بعد الاعتماد"
  },
  "publish": {
    "title": "نشر {{name}}؟",
    "body": "تصبح المسودة {{n}} هي النسخة المنشورة.",
    "problems_zero": "لا مشكلات تمنع النشر",
    "problems_one": "مشكلة واحدة تمنع النشر",
    "problems_two": "مشكلتان تمنعان النشر",
    "problems_few": "{{n}} مشكلات تمنع النشر",
    "problems_many": "{{n}} مشكلة تمنع النشر",
    "problems_other": "{{n}} مشكلة تمنع النشر",
    "warnings_zero": "لا تنبيهات",
    "warnings_one": "تنبيه واحد",
    "warnings_two": "تنبيهان",
    "warnings_few": "{{n}} تنبيهات",
    "warnings_many": "{{n}} تنبيهًا",
    "warnings_other": "{{n}} تنبيه",
    "ready": "لا توجد مشكلات تمنع النشر.",
    "showProblems": "عرضها في المُنشئ",
    "inStep": "الخطوة {{n}} ({{name}})",
    "area": {
      "conditions": "ينطبق على",
      "steps": "الخطوات",
      "outcome": "الإجراء بعد الاعتماد",
      "other": "المسار"
    },
    "actionNote": "عند الاعتماد تُرحَّل المشتريات تلقائيًا: {{action}}.",
    "actionMissing": "ترحّل هذه النسخة المشتريات تلقائيًا، ونشرها يتطلب صلاحية «{{permission}}» التي لا تملكها.",
    "impactTitle": "ما الذي سيحدث",
    "impactRunning_zero": "لا توجد طلبات جارية على النسخة {{version}}.",
    "impactRunning_one": "يبقى الطلب الجاري الواحد على النسخة {{version}} ويكتمل عليها.",
    "impactRunning_two": "يبقى الطلبان الجاريان على النسخة {{version}} ويكتملان عليها.",
    "impactRunning_few": "تبقى {{n}} طلبات جارية على النسخة {{version}} وتكتمل عليها.",
    "impactRunning_many": "يبقى {{n}} طلبًا جاريًا على النسخة {{version}} ويكتمل عليها.",
    "impactRunning_other": "يبقى {{n}} طلب جارٍ على النسخة {{version}} ويكتمل عليها.",
    "impactFirst": "هذه أول نسخة منشورة.",
    "impactNew": "تستخدم الطلبات الجديدة من الآن النسخة {{n}}.",
    "impactEnables": "النشر يفعّل المسار أيضًا.",
    "nothing": "لا توجد تغييرات للنشر."
  },
  "detail": {
    "tabs": "أقسام المسار",
    "disabledNote": "هذا المسار موقوف: تتجاوزه الطلبات الجديدة، وتكتمل الطلبات الجارية على نسختها.",
    "publishedTitle": "النسخة المنشورة {{n}}",
    "notPublished": "لم يُنشر بعد",
    "notPublishedBody": "أنشئ الخطوات واختبرها، ثم انشر المسار ليبدأ توجيه المشتريات.",
    "requestsTitle": "الطلبات الحالية",
    "count": {
      "inProgress": "جارية",
      "blocked": "متوقفة",
      "failed": "إجراء متعثر"
    },
    "runningNote": "تكتمل الطلبات على النسخة التي بدأت بها، مهما تغيّر بعد ذلك."
  },
  "tabs": {
    "overview": "نظرة عامة",
    "builder": "المُنشئ",
    "runs": "الطلبات",
    "versions": "النسخ",
    "audit": "السجل"
  },
  "priority": {
    "title": "الترتيب",
    "help": "إذا طابقت عدة مسارات المشتريات نفسها يُستخدم صاحب الرقم الأصغر. تغييره يغيّر التوجيه، لذا لا يغيّره إلا الناشرون.",
    "change": "تغيير الترتيب",
    "invalid": "أدخل عددًا صحيحًا من 1 إلى 9999.",
    "publisherOnly": "لا يغيّر الترتيب إلا الناشرون."
  },
  "runs": {
    "label": "طلبات هذا المسار",
    "document": "المستند",
    "status": "الحالة",
    "step": "الخطوة الحالية",
    "stepOf": "{{n}} من {{total}}",
    "requester": "قدّمه",
    "version": "النسخة",
    "submitted": "تاريخ التقديم",
    "empty": "لا توجد طلبات بعد",
    "emptyBody": "تظهر الطلبات هنا بعد تقديم مشتريات عبر هذا المسار.",
    "denied": "لا يمكنك الاطلاع على طلبات الاعتماد",
    "deniedBody": "متابعة الطلبات تتطلب صلاحية خاصة بها.",
    "all": "جميع الطلبات ({{n}})"
  },
  "versions": {
    "number": "ن{{n}}",
    "status": {
      "DRAFT": "مسودة",
      "PUBLISHED": "منشورة",
      "RETIRED": "متقاعدة"
    },
    "publishedBy": "نُشرت {{at}} بواسطة {{name}}",
    "createdBy": "أُنشئت {{at}} بواسطة {{name}}",
    "runs_zero": "لا طلبات",
    "runs_one": "طلب واحد",
    "runs_two": "طلبان",
    "runs_few": "{{n}} طلبات",
    "runs_many": "{{n}} طلبًا",
    "runs_other": "{{n}} طلب",
    "view": "عرض",
    "hide": "إخفاء",
    "empty": "لا توجد نسخ بعد"
  },
  "audit": {
    "denied": "عرض السجل يتطلب صلاحية الاطلاع على سجل التدقيق",
    "empty": "لم تُسجَّل تغييرات بعد",
    "system": "النظام"
  },
  "exclusion": {
    "REQUESTER": "أعدّ المستند أو قدّمه",
    "USER_INACTIVE": "مستخدم غير نشط",
    "MISSING_PERMISSION": "لا يملك صلاحية اعتماد المشتريات",
    "PRIOR_APPROVER": "اعتمد مرحلة سابقة",
    "NOT_ASSIGNED": "غير مُسند إلى هذه المرحلة",
    "SUBJECT_MODULE_OFF": "المشتريات معطّلة لشركتك"
  },
  "test": {
    "title": "اختبار المسار",
    "subtitle": "اعرف أي مسار ستحصل عليه المشتريات ومن سيعتمدها.",
    "target": "ما الذي يُختبر",
    "targets": {
      "LIVE": "التوجيه الفعلي (كل المسارات النشطة بالترتيب)",
      "DRAFT": "مسودة هذا المسار (النسخة {{n}}) وحدها",
      "PUBLISHED": "النسخة المنشورة {{n}} من هذا المسار وحدها"
    },
    "unsaved": "يستخدم الاختبار المسودة المحفوظة. احفظ تغييراتك لتشملها.",
    "source": "الاختبار باستخدام",
    "synthetic": "قيم تجريبية",
    "syntheticHint": "قيم تكتبها بنفسك؛ لا يُستخدم أي مستند حقيقي.",
    "syntheticLegend": "قيم تجريبية (افتراضية)",
    "document": "مسودة مشتريات",
    "documentHint": "تُؤخذ القيم ومُعِدّ المستند من المشتريات نفسها.",
    "documentDenied": "يتطلب صلاحية الاطلاع على المشتريات.",
    "purchase": "المشتريات",
    "purchasePlaceholder": "اختر مسودة مشتريات",
    "purchasesFailed": "تعذّر تحميل المشتريات.",
    "noPurchases": "لا توجد مسودات مشتريات مطابقة.",
    "requester": "قدّمه",
    "requesterHint": "اختياري. يُستبعد هذا الشخص من الاعتماد.",
    "noRequester": "لا أحد بعينه",
    "run": "تشغيل الاختبار",
    "readOnly": "اختبار للقراءة فقط — لم يُغيَّر أو يُرسَل أي شيء",
    "readOnlySynthetic": "هذه النتائج للقيم التجريبية أعلاه.",
    "readOnlyDocument": "هذه النتائج لـ {{label}}؛ ولم تُقدَّم المشتريات.",
    "outcome": {
      "NO_APPROVAL_NEEDED": "لا ينطبق أي مسار: يمكن ترحيل المشتريات دون اعتماد.",
      "WOULD_WAIT_FOR_APPROVAL": "ستنتظر المشتريات الاعتماد عبر {{name}} (النسخة {{n}}).",
      "WOULD_BLOCK": "سيتوقف الطلب: في إحدى الخطوات لا يوجد من يستطيع الاعتماد، وسيُنبَّه المسؤولون.",
      "ALREADY_PENDING": "هذه المشتريات تنتظر الاعتماد بالفعل."
    },
    "factsTitle": "القيم المستخدمة",
    "consideredTitle": "المسارات التي فُحصت بالترتيب",
    "noneConsidered": "لا يوجد مسار نشط لنوع المستند هذا.",
    "consideredMeta": "ن{{n}} · الترتيب {{order}}",
    "sources": {
      "DRAFT": "مسودة",
      "PUBLISHED": "منشورة"
    },
    "matched": "مطابق",
    "notMatched": "غير مطابق",
    "selected": "المختار",
    "earlierWon": "اختير مسار أسبق منه في الترتيب.",
    "noConditions": "بلا شروط: ينطبق على كل المشتريات.",
    "actual": "القيمة",
    "emptyValue": "فارغ",
    "passed": "متحقق",
    "failed": "غير متحقق",
    "stepsTitle": "الخطوات",
    "whenHeld": "تعمل لأن:",
    "whenFailed": "تُتجاوز لأن:",
    "skipped": "مُتجاوَزة",
    "blocked": "متوقفة",
    "eligible": "سيعتمدها",
    "nobody": "لا يوجد من يستطيع اعتماد هذه الخطوة.",
    "excluded": "المستبعَدون",
    "missing_zero": "كل المستخدمين والأدوار المضبوطة موجودة.",
    "missing_one": "مستخدم أو دور مضبوط واحد لم يعد موجودًا.",
    "missing_two": "مستخدمان أو دوران مضبوطان لم يعودا موجودين.",
    "missing_few": "{{n}} مستخدمين أو أدوار مضبوطة لم تعد موجودة.",
    "missing_many": "{{n}} مستخدمًا أو دورًا مضبوطًا لم يعد موجودًا.",
    "missing_other": "{{n}} مستخدم أو دور مضبوط لم يعد موجودًا.",
    "blockedText": "لا يوجد معتمِد مؤهل: سيتوقف الطلب هنا وسيُنبَّه المسؤولون.",
    "finalTitle": "الإجراء بعد الاعتماد",
    "finalAction": "ثم: {{action}}",
    "group": {
      "all": "كل هذه الشروط",
      "any": "أيٌّ من هذه الشروط",
      "none": "لا شيء من هذه الشروط",
      "notAll": "ليست كل هذه الشروط"
    },
    "holds": "متحقق",
    "notMet": "غير متحقق",
    "traceLabel": "سبب المطابقة أو عدمها",
    "walks": "من تم تجاوزه أثناء الصعود",
    "remindAt": "التذكير في {{date}}",
    "dueAt": "الاستحقاق في {{date}}"
  },
  "changes": {
    "title": "ما الذي يتغير عن النسخة {{n}}",
    "first": "النسخة الأولى: لا توجد نسخة منشورة للمقارنة.",
    "none": "لا تغييرات عن النسخة المنشورة.",
    "appliesTo": "ينطبق على",
    "before": "قبل",
    "after": "بعد",
    "added": "خطوة مضافة",
    "removed": "خطوة محذوفة",
    "changed": "خطوة معدّلة",
    "action": "الإجراء بعد الاعتماد",
    "aspect": {
      "name": "الاسم",
      "approvers": "المعتمِدون",
      "completion": "عدد من يجب أن يعتمد",
      "when": "متى تعمل",
      "timing": "التوقيت",
      "separation": "الفصل بين المهام",
      "order": "الموضع"
    }
  },
  "subjectOff": {
    "purchase": {
      "title": "المشتريات معطّلة لشركتك",
      "body": "تبقى مسارات اعتماد المشتريات محفوظة، لكنها لا توجّه أي مستند حتى يُعاد تفعيل المشتريات: طلبات اعتماد المشتريات المفتوحة معلّقة، ولا يمكن إنشاء مسارات اعتماد للمشتريات أو نشرها في هذه الأثناء."
    },
    "project_budget": {
      "title": "المشاريع معطّلة لشركتك",
      "body": "تبقى مسارات اعتماد موازنات المشاريع محفوظة، لكنها لا توجّه أي موازنة حتى يُعاد تفعيل المشاريع: طلبات اعتماد الموازنات المفتوحة معلّقة، ولا يمكن إنشاء مسارات اعتماد للموازنات أو نشرها في هذه الأثناء."
    },
    "project_variation": {
      "title": "المشاريع معطّلة لشركتك",
      "body": "تُحفظ مسارات الأوامر التغييرية لكنها لا توجّه شيئًا حتى يُعاد تفعيل المشاريع: الطلبات المفتوحة معلّقة، ولا يمكن إنشاء مسارات للأوامر التغييرية أو نشرها في الأثناء."
    },
    "project_claim": {
      "title": "المشاريع معطّلة لشركتك",
      "body": "تُحفظ مسارات المستخلصات لكنها لا توجّه شيئًا حتى يُعاد تفعيل المشاريع: الطلبات المفتوحة معلّقة، ولا يمكن إنشاء مسارات للمستخلصات أو نشرها في الأثناء."
    },
    "service_contract": {
      "title": "عقود الصيانة معطّلة لشركتك",
      "body": "تُحفظ مسارات اعتماد العقود لكنها لا توجّه شيئًا حتى يُعاد تفعيل عقود الصيانة: الطلبات المفتوحة معلّقة، ولا يمكن إنشاء مسارات للعقود أو نشرها في الأثناء."
    }
  }
}
